export default class ManageFormFieldVisibility {

  constructor (form) {

    this.form = form

    this.servicesHiddenFields = this.getServiceHiddenFields()

    if(!this.servicesHiddenFields.length) return;

    this.setServiceFields()

    this.manageServiceFields()

  }

  getServiceHiddenFields() {

    const hiddenFields = this.form.querySelectorAll('[data-service-hidden]');
    const response = []

    hiddenFields.forEach(field => {

      const servicesArray = field.getAttribute('data-service-hidden').split(',')

      if(!servicesArray.length) return;

      servicesArray.forEach((service_id, value) => {

        if(response[service_id]) {
          response[service_id] = response[service_id].concat(field)
        } else {
          response[service_id] = [field]
        }

      })

    })

    return response

  }

  setServiceFields() {
    const selectedService = this.form.querySelector('.form-field-select-services')

    if(!selectedService) return;

    const select = selectedService.querySelector('select')
    const value = select.value

    // reset all fields
    this.resetServicesHiddenFields()

    // hide selected fields
    this.hideServicesSelectedHiddenFields(value)
  }

  manageServiceFields() {

    const self = this
    const selectedService = this.form.querySelector('.form-field-select-services')

    if(!selectedService) return;

    const select = selectedService.querySelector('select')
    const value = select.value

    select.addEventListener('change', function (e) {

      const newValue = e.target.value

      // reset all fields
      self.resetServicesHiddenFields()

      // hide selected fields
      self.hideServicesSelectedHiddenFields(newValue)
    })

  }

  resetServicesHiddenFields() {
    this.servicesHiddenFields.forEach((fields, key) => {
      fields.forEach(field => {
        field.classList.remove('d-none')
      })
    })
  }

  hideServicesSelectedHiddenFields(id) {
    if(this.servicesHiddenFields[id]) {
      this.servicesHiddenFields[id].forEach(field => {
        field.classList.add('d-none')
      })
    }
  }

}
